import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';

export interface PropertyReceivable {
  id: number;
  property_id: number;
  property_name: string;
  guest_name: string;
  reservation_dates: string;
  channel: string;
  description: string;
  amount_due: number;
  amount_paid: number;
  due_date: string;
  paid_date: string;
  status: string;
  created_at: string;
  updated_at: string;
}

const DUMMY_RECEIVABLES: PropertyReceivable[] = [
  {
    id: 1,
    property_id: 101,
    property_name: 'Beach House',
    guest_name: 'Emily R.',
    reservation_dates: 'Feb 1–5, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (4 nights)',
    amount_due: 1200,
    amount_paid: 1200,
    due_date: '2026-01-25',
    paid_date: '2026-01-25',
    status: 'Paid',
    created_at: '2026-01-20T00:00:00Z',
    updated_at: '2026-01-25T00:00:00Z',
  },
  {
    id: 2,
    property_id: 101,
    property_name: 'Beach House',
    guest_name: 'Emily R.',
    reservation_dates: 'Feb 1–5, 2026',
    channel: 'Airbnb',
    description: 'Cleaning fee',
    amount_due: 150,
    amount_paid: 150,
    due_date: '2026-01-25',
    paid_date: '2026-01-25',
    status: 'Paid',
    created_at: '2026-01-20T00:00:00Z',
    updated_at: '2026-01-25T00:00:00Z',
  },
  {
    id: 3,
    property_id: 101,
    property_name: 'Beach House',
    guest_name: 'Jordan M.',
    reservation_dates: 'Feb 20–25, 2026',
    channel: 'VRBO',
    description: 'Nightly rate (5 nights)',
    amount_due: 1500,
    amount_paid: 750,
    due_date: '2026-02-13',
    paid_date: '',
    status: 'Partial',
    created_at: '2026-02-01T00:00:00Z',
    updated_at: '2026-02-13T00:00:00Z',
  },
  {
    id: 4,
    property_id: 102,
    property_name: 'Mountain Cabin',
    guest_name: 'Sarah & Jake L.',
    reservation_dates: 'Jan 28 – Feb 2, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (5 nights)',
    amount_due: 1250,
    amount_paid: 1250,
    due_date: '2026-01-21',
    paid_date: '2026-01-21',
    status: 'Paid',
    created_at: '2026-01-15T00:00:00Z',
    updated_at: '2026-01-21T00:00:00Z',
  },
  {
    id: 5,
    property_id: 102,
    property_name: 'Mountain Cabin',
    guest_name: 'Chris D.',
    reservation_dates: 'Feb 10–15, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (5 nights) + pet fee',
    amount_due: 1450,
    amount_paid: 0,
    due_date: '2026-02-03',
    paid_date: '',
    status: 'Overdue',
    created_at: '2026-01-28T00:00:00Z',
    updated_at: '2026-02-03T00:00:00Z',
  },
  {
    id: 6,
    property_id: 103,
    property_name: 'City Apartment',
    guest_name: 'Tom W.',
    reservation_dates: 'Jan 15–19, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (4 nights)',
    amount_due: 900,
    amount_paid: 900,
    due_date: '2026-01-08',
    paid_date: '2026-01-08',
    status: 'Paid',
    created_at: '2026-01-03T00:00:00Z',
    updated_at: '2026-01-08T00:00:00Z',
  },
  {
    id: 7,
    property_id: 103,
    property_name: 'City Apartment',
    guest_name: 'Diana K.',
    reservation_dates: 'Feb 10–14, 2026',
    channel: 'Booking.com',
    description: 'Nightly rate (4 nights)',
    amount_due: 880,
    amount_paid: 880,
    due_date: '2026-02-03',
    paid_date: '2026-02-03',
    status: 'Paid',
    created_at: '2026-01-28T00:00:00Z',
    updated_at: '2026-02-03T00:00:00Z',
  },
  {
    id: 8,
    property_id: 104,
    property_name: 'Lake House',
    guest_name: 'The Martinez Family',
    reservation_dates: 'Feb 7–12, 2026',
    channel: 'VRBO',
    description: 'Nightly rate (5 nights) + pet fee',
    amount_due: 1800,
    amount_paid: 1800,
    due_date: '2026-01-31',
    paid_date: '2026-01-31',
    status: 'Paid',
    created_at: '2026-01-25T00:00:00Z',
    updated_at: '2026-01-31T00:00:00Z',
  },
  {
    id: 9,
    property_id: 104,
    property_name: 'Lake House',
    guest_name: 'Rebecca N.',
    reservation_dates: 'Jan 5–9, 2026',
    channel: 'Direct',
    description: 'Nightly rate (4 nights)',
    amount_due: 1080,
    amount_paid: 1080,
    due_date: '2025-12-29',
    paid_date: '2025-12-29',
    status: 'Paid',
    created_at: '2025-12-22T00:00:00Z',
    updated_at: '2025-12-29T00:00:00Z',
  },
  {
    id: 10,
    property_id: 105,
    property_name: 'Downtown Loft',
    guest_name: 'Alex P.',
    reservation_dates: 'Feb 14–17, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (3 nights)',
    amount_due: 675,
    amount_paid: 0,
    due_date: '2026-02-07',
    paid_date: '',
    status: 'Pending',
    created_at: '2026-02-01T00:00:00Z',
    updated_at: '2026-02-01T00:00:00Z',
  },
  {
    id: 11,
    property_id: 105,
    property_name: 'Downtown Loft',
    guest_name: 'Alex P.',
    reservation_dates: 'Feb 14–17, 2026',
    channel: 'Airbnb',
    description: 'Cleaning fee',
    amount_due: 100,
    amount_paid: 0,
    due_date: '2026-02-07',
    paid_date: '',
    status: 'Pending',
    created_at: '2026-02-01T00:00:00Z',
    updated_at: '2026-02-01T00:00:00Z',
  },
  {
    id: 12,
    property_id: 105,
    property_name: 'Downtown Loft',
    guest_name: 'Nina S.',
    reservation_dates: 'Jan 8–12, 2026',
    channel: 'Airbnb',
    description: 'Nightly rate (4 nights) + early check-in',
    amount_due: 950,
    amount_paid: 950,
    due_date: '2026-01-01',
    paid_date: '2026-01-01',
    status: 'Paid',
    created_at: '2025-12-25T00:00:00Z',
    updated_at: '2026-01-01T00:00:00Z',
  },
];

@Injectable({
  providedIn: 'root'
})
export class PropertyReceivablesService {

  private http = inject(HttpClient);
  private useDummyData = true;

  async getPropertyReceivables(): Promise<PropertyReceivable[]> {
    if (this.useDummyData) {
      return DUMMY_RECEIVABLES;
    }
    return firstValueFrom(
      this.http.get<PropertyReceivable[]>(`${environment.api_url}api/v1/customer/property-receivables`)
    );
  }

  async createPropertyReceivable(receivable: Partial<PropertyReceivable>): Promise<PropertyReceivable> {
    if (this.useDummyData) {
      const newReceivable: PropertyReceivable = {
        id: DUMMY_RECEIVABLES.length + 1,
        property_id: receivable.property_id || 0,
        property_name: receivable.property_name || '',
        guest_name: receivable.guest_name || '',
        reservation_dates: receivable.reservation_dates || '',
        channel: receivable.channel || '',
        description: receivable.description || '',
        amount_due: receivable.amount_due || 0,
        amount_paid: receivable.amount_paid || 0,
        due_date: receivable.due_date || '',
        paid_date: receivable.paid_date || '',
        status: receivable.status || 'Pending',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };
      DUMMY_RECEIVABLES.push(newReceivable);
      return newReceivable;
    }
    return firstValueFrom(
      this.http.post<PropertyReceivable>(`${environment.api_url}api/v1/customer/property-receivables`, receivable)
    );
  }

  async updatePropertyReceivable(id: number, receivable: Partial<PropertyReceivable>): Promise<PropertyReceivable> {
    if (this.useDummyData) {
      const idx = DUMMY_RECEIVABLES.findIndex(r => r.id === id);
      if (idx >= 0) {
        DUMMY_RECEIVABLES[idx] = { ...DUMMY_RECEIVABLES[idx], ...receivable, updated_at: new Date().toISOString() };
        return DUMMY_RECEIVABLES[idx];
      }
      throw new Error('Receivable not found');
    }
    return firstValueFrom(
      this.http.put<PropertyReceivable>(`${environment.api_url}api/v1/customer/property-receivables/${id}`, receivable)
    );
  }

  async deletePropertyReceivable(id: number): Promise<void> {
    if (this.useDummyData) {
      const idx = DUMMY_RECEIVABLES.findIndex(r => r.id === id);
      if (idx >= 0) {
        DUMMY_RECEIVABLES.splice(idx, 1);
      }
      return;
    }
    return firstValueFrom(
      this.http.delete<void>(`${environment.api_url}api/v1/customer/property-receivables/${id}`)
    );
  }
}
